import { Injectable } from '@angular/core';
// import { MatomoTracker } from 'ngx-matomo';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SpaContext } from 'Public_old/src/app/Classes/spacontext';
import { ApiResponse, VisibaApiHttp } from 'Public_old/src/app/Classes/visibaHttp.class';
import { TimeSlotLockApiModel } from './Models/TimeSlotLockApiModel';

@Injectable()
export class TimeSlotLockApiService {
	private readonly baseUri = '/api/Client/v2/units/';
	public currentLock: string = null;

	constructor(
		private http: VisibaApiHttp,
		private spaContext: SpaContext,
		/*private matomoTracker: MatomoTracker,*/
	) {}

	public lockTimeSlot(timeSlotId: string): Observable<ApiResponse<TimeSlotLockApiModel>> {
		return this.http
			.postTyped<TimeSlotLockApiModel>(`${this.baseUri}${this.spaContext.unitConfig.ReceptionId}/timeslots/${timeSlotId}/locks`, {})
			.pipe(
				map(
					(res) => {
						this.currentLock = res.data.Id;

						return res;
					},
					() => {
						this.currentLock = null;
					},
				),
			);
	}

	public removeLockOnTimeSlot(): Observable<unknown> {
		if (this.currentLock === null) {
			return of(null);
		}

		// this.matomoTracker.trackEvent('SelectTime-view', 'Lock released manually');

		return this.http.delete(`${this.baseUri}${this.spaContext.unitConfig.ReceptionId}/timeslotlocks/${this.currentLock}`);
	}
}
